module.exports = __webpack_public_path__ + "img/1726043987967-screenshot-1726043941737.png.8afb27f3.webp";